






























import {
  defineComponent,
  onMounted,
  ref,
  toRefs,
  watch,
  PropType
} from '@vue/composition-api'
import KaiSpeaker from '../../components/transcript/KaiSpeaker.vue'
import TranscriptPartWords from '../../components/TranscriptPartWords.vue'
import { useGetters } from '../../store/useGetters'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { Word } from '../../models/word'

export default defineComponent({
  name: 'transcript-part',
  emits: ['word-click', 'text-select'],
  components: {
    KaiSpeaker,
    TranscriptPartWords
  },
  props: {
    isPlaying: {
      type: Boolean,
      required: true
    },
    speakerName: {
      type: String
    },
    speakerId: {
      type: Number
    },
    speakerColor: {
      type: String
    },
    partId: {
      type: String
    },
    timecode: {
      type: Number,
      required: true
    },
    words: {
      type: Array as PropType<Word[]>,
      required: true,
      default: () => []
    },
    isEditable: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup(props, { emit }) {
    const { isEditable, words, partId } = toRefs(props)
    const spelled = ref(false)

    const _words = ref<Word[]>([])

    const getters = useGetters({
      selectedSpeakerPartTimecode: 'conversation/selectedSpeakerPartTimecode',
      spelledPartId: 'conversation/spelledPartId'
    })

    function handlePartFocus() {
      if (isEditable.value) {
        emit('part-focus')
      }
    }

    function isWordSpelled(word: Word) {
      // const isSpelled = spelled.value.find((w: Word) => w.id === word.id)
      //
      // if (isSpelled) {
      //     return true
      // }
      return false
    }

    function wordClassList(word: Word) {
      const fullyRoundedClass = word.isFullyBordered ? 'fully-rounded' : ''
      const topBottomBorderClass = word.hasTopBottomBorder
        ? 'border-top-bottom'
        : ''
      const roundedLeftClass = word.isRoundedLeft ? 'rounded-left' : ''
      const roundedRightClass = word.isRoundedRight ? 'rounded-right' : ''
      const withBackgroundClass = word.isBackground ? 'with-background' : ''
      const wordHClass = !isEditable.value ? 'word-h' : ''
      const wordEditableClass = isEditable.value ? 'word-editable' : ''
      const wordEditableUnderlineClass = isEditable.value
        ? 'border-blue-defaultLight'
        : 'border-gray-110'

      let cur = ''
      if (!isEditable.value && isWordSpelled(word)) {
        cur = 'current'
      }

      return [
        'relative',
        'word',
        'text-item',
        'inline-block',
        wordEditableUnderlineClass,
        fullyRoundedClass,
        topBottomBorderClass,
        roundedLeftClass,
        cur,
        roundedRightClass,
        withBackgroundClass,
        wordHClass,
        wordEditableClass
      ]
    }

    function mapWordsStyles(_words: Word[]) {
      return _words.map((w, i) => {
        return {
          ...w,
          styles: wordClassList(w)
        }
      })
    }

    function updateWordsStyles() {
      _words.value = mapWordsStyles(words.value)
    }

    // watch(spelled, (p, n) => {
    //     if (JSON.stringify(p) !== JSON.stringify(n)) {
    //         updateWordsStyles()
    //     }
    // })

    watch(words, () => {
      console.log('watched words')
      updateWordsStyles()
    })

    watch(getters.spelledPartId, () => {
      if (partId?.value === getters.spelledPartId.value) {
        spelled.value = true
      } else if (spelled.value) {
        spelled.value = false
      }
    })

    onMounted(updateWordsStyles)

    return {
      ...getters,
      spelled,
      selectedSpeakerPartTimecode: getters.selectedSpeakerPartTimecode,
      handlePartFocus,
      _words,
      userIcon: faUser
    }
  }
})
